import { render, staticRenderFns } from "./ToyEditor.vue?vue&type=template&id=6cc8c189&"
import script from "./ToyEditor.vue?vue&type=script&lang=js&"
export * from "./ToyEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports